import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import VidHoriz from "../components/VidHoriz";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "20px 5%",
    paddingBottom: "70px",
  },
}));

function Videos() {
  const classes = useStyles();
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    axios
      .get(
        `https://www.googleapis.com/youtube/v3/playlists?part=snippet&channelId=UCFMw0qOFSeHjZ6CLhxNw2VA&key=AIzaSyDgfKXwTciB7sNrsPXHX08IduS4it0wqY0`
      )
      .then((res) => {
        setVideos(
          res.data.items.map((item) => {
            return {
              id: item.id,
              title: item.snippet.localized.title,
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  console.log(
    videos.sort((a, b) => {
      const nameA = a?.title.toUpperCase(); // ignore upper and lowercase
      const nameB = b?.title.toUpperCase(); // ignore upper and lowercase
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    })
  );

  return (
    <>
      <Helmet>
        <title>Help Videos</title>
        <meta
          name="description"
          content="Check out some of our main help, tips and demo videos"
        />
      </Helmet>
      <div className={classes.root}>
        <Typography variant="h4">Featured Videos:</Typography>
        <Typography style={{ marginBottom: "50px" }}>
          Check out our main help and promo videos below:
        </Typography>
        <Grid container spacing={5} justifyContent="center">
          {videos.map((vid, index) => (
            <Grid key={index} item xs={12} md={6} lg={4}>
              <VidHoriz videoLink={vid.id} description={`${vid?.title}`} />
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
}

export default Videos;
